import KeyIcon from "@mui/icons-material/Key";
import { nacidRequests } from "api/nacidApi";
import { TextInput, regex, required, useNotify, useRefresh } from "react-admin";
import dataProvider from "server/dataProvider";
import FormModal from "server/components/Modals/FormModal";
import { NACID_EAN_PATTERN } from "utils/constants";
import { Button } from "@mui/material";

const validateEan = [
  required(),
  regex(NACID_EAN_PATTERN, "Очакват се две латински букви и пет цифри, например AB12345."),
];

// For a foreigner identified only by ИДН, NACID issues the ЕАН out of band: a human attaches a scanned identity
// document in NACID's UI and waits for approval. There is no callback, webhook or polling API — an operator
// pasting the result back in is a designed path, not a workaround.
//
// The backend does NOT take the ЕАН and stop there: it records it, re-arms the flow, and lets the engine run
// the step that publishes StudentEanAssigned. So a flow blocked on this one resumes on its own.
const ResolveStepEanDialog = ({ flowId, stepId }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleConfirm = async data => {
    await dataProvider.customRequest(
      nacidRequests.resolveStepManually(flowId, stepId),
      { ean: data.ean, note: data.note },
      "POST",
    );

    notify("ЕАН е записан. Потокът продължава автоматично.", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      onConfirm={handleConfirm}
      titleContent="Въвеждане на ЕАН от НАЦИД"
      saveTitle="Запиши ЕАН"
      dialogSize="md"
      triggerButton={
        <Button
          label="Въведи ЕАН ръчно"
          startIcon={<KeyIcon />}
        />
      }
    >
      <TextInput
        source="ean"
        label="ЕАН"
        validate={validateEan}
        fullWidth
        helperText="Копирайте го от УИ на НАЦИД или от Excel експорта. Буквите I, J, O, U и W не се използват."
      />
      <TextInput
        source="note"
        label="Бележка"
        multiline
        rows={2}
        fullWidth
      />
    </FormModal>
  );
};

export default ResolveStepEanDialog;
